import linkifyIt from 'linkify-it';

const SCHEMAS = [
    'git',
    'onepassword',
    'skype',
    'sftp',
    'slack',
    'smb',
    'tel',
];

const isInternalLink = text => text.startsWith(`/teams/${window.teamDomain}/`);

const findLink = linkifyIt();

SCHEMAS.forEach(scheme => findLink.add(`${scheme}:`, 'http:'));

const hasUrlScheme = text => text.includes('://');

const internalToAbsolute = link => (isInternalLink(link) ? window.location.origin + link : link);

export {
    isInternalLink, findLink, hasUrlScheme, internalToAbsolute,
};
